import { EscalatedIncidentsModal} from "./EscalatedIncidentsModal";

export default EscalatedIncidentsModal;
